export default {
  state: {
    details: {
    },
    rsvp1: {},
    rsvp2: {},
    rsvp3: {},
    rsvp4: {},
    trx: {
      list: [],
      id: ''
    }
  },
  mutations: {
    setFlightDetails (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    setFlightTrxData (state, data) {
      for (let field in data) {
        state.trx[field] = data[field]
      }
    },
    updateRsvpStatus (state, data) {
      state[data.target].status = data.val
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/flight-details/details.js